"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const auth_component_1 = require("./auth.component");
const oauth_component_1 = require("./oauth.component");
const global_1 = require("../commons/global");
const activate_component_1 = require("./activate.component");
const forget_component_1 = require("./forget.component");
const AppRouting = [
    { path: '', component: auth_component_1.AuthComponent, pathMatch: 'full' },
    { path: 'forget/:tok', component: forget_component_1.ForgetComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.EMAIL, component: auth_component_1.LoginEmailComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.SIGNUP, component: auth_component_1.SignupComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.ACTIVATE_ACC, component: activate_component_1.ActivateComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.ACTIVATE_ACC_GRP, component: activate_component_1.ActivateComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.ACTIVATE_NO_ACC, component: activate_component_1.ActivateComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.OAUTH, component: oauth_component_1.OAuthComponent, pathMatch: 'full' },
    { path: 'share/:token/:secret', component: oauth_component_1.OAuthComponent, pathMatch: 'full' },
    { path: global_1.AppRoutes.MSG, component: auth_component_1.AuthComponent, pathMatch: 'full' }
];
class AuthModule {
}
exports.AuthModule = AuthModule;
